import React, { FC } from 'react';
import './styles.scss';
import HistoryTabItem, { HistoryIconColor } from './history-item';
import { HistoryItemType } from './types';

type HistoryTab = {
  loading?: boolean;
  historyList: HistoryItemType[];
  color: HistoryIconColor;
};
const HistoryTab: FC<HistoryTab> = ({ loading, historyList, color }) => {
  return (
    <div className='history-tab'>
      <div className='py-3'>
        {loading ? (
          <div className='place-content-center place-items-center flex h-full'>Loading...</div>
        ) : historyList.length === 0 ? (
          <div className='place-content-center place-items-center flex h-full'>
            No history to show
          </div>
        ) : (
          historyList.map((item) => <HistoryTabItem color={color} list={item} key={item.id} />)
        )}
      </div>
    </div>
  );
};

export default HistoryTab;
